import React, { useEffect, useState } from 'react'
import GetLandDocumentTypeList from '../../APIs/Master/LandDocumentTypeMaster/GetLandDocumentTypeList'
import Loader from '../../components/Loader';
import SideMessage from '../../components/SideMessage';
import GetIdentityDocumentTypeList from '../../APIs/Master/IdentityDocumentTypeMaster/GetIdentityDocumentTypeList';
import FileUpload from '../../components/FileUpload';
import FileUploadAPI from '../../assets/js/fileUpload';
import GetLandAgreementByLandId from '../../APIs/Land/GetLandAgreementByLandId';

export default function AddAgreementHolder(props) {
    let [identityTypeList, setIdentityTypeList] = useState([]);
    const [sendForm, setSendForm] = useState({
        name: "",
        dob: "",
        identityTypeId: 0,
        documentId: ""
    });
    let [isUpdate, setIsUpdate] = useState(0);
    let [loader, setLoader] = useState(0)
    let [sideToster, setSideToster] = useState({
        show: 0,
        message: '',
        type: ''
    });
    let [deletedImages, setDeletedImages] = useState([]);
    let [allImage, setAllImage] = useState([]);

    let getIdentityDocumentTypeData = async () => {
        let respIdentityType = await GetIdentityDocumentTypeList()
        if (respIdentityType.status === 1) {
            setIdentityTypeList(respIdentityType.responseValue)
        }
        else {
            setIdentityTypeList([])
        }
    }
    let getLandAgreementData = async (id) => {
        let resp = await GetLandAgreementByLandId(id);
        if (resp.status === 1 && resp.responseValue.length !== 0) {
            let data = resp.responseValue
            let allData = resp.responseValue.imageDetails
            console.log("data", data)
            setAllImage(allData)
            setSendForm({ ...data })
            setIsUpdate(1)
        }
        else {

        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSendForm(prev => ({ ...prev, [name]: value }));
    }

    const validateForm = () => {
        if (!sendForm.name || sendForm.name.trim() === "") {
            return "Name is required";
        }

        if (!sendForm.dob) {
            return "DOB is required";
        }

        if (!sendForm.identityTypeId || sendForm.identityTypeId === "-1") {
            return "Identity Type is required";
        }

        if (!sendForm.identityNumber || sendForm.identityNumber.trim() === "") {
            return "Identity Number is required";
        }

        // IMPORTANT: image must never be empty
        if (!allImage || allImage.length === 0) {
            return "At least one document/image is required";
        }

        return null;
    };

    const handleSave = async () => {
        try {

            const error = validateForm();
            if (error) {
                setSideToster({
                    show: 1,
                    message: error,
                    type: "Alert"
                });
                return;
            }

            let formdata = new FormData();

            formdata.append("LandId", JSON.parse(window.sessionStorage.getItem("ProjectData")).landData.id);
            formdata.append("Name", sendForm.name);
            formdata.append("DOB", sendForm.dob);
            formdata.append("IdentityTypeId", sendForm.identityTypeId);
            formdata.append("IdentityNumber", sendForm.identityNumber);

            allImage.forEach((val) => {
                formdata.append("AgreementFiles", val);
            });

            setLoader(1);

            let response = await FileUploadAPI(
                formdata,
                window.RealestateService + `/api/LandAgreement/InsertLandAgreement`
            );

            let resp = response.data;

            setLoader(0);

            if (resp.status === 1) {
                setSideToster({
                    show: 1,
                    message: "Data Saved",
                    type: "success"
                });

                props.handleActiveTab(2);
            } else {
                setSideToster({
                    show: 1,
                    message: resp.responseValue,
                    type: "Alert"
                });
            }

        } catch (err) {
            setLoader(0);
            setSideToster({
                show: 1,
                message: err.message,
                type: "Alert"
            });
        }
    };

    const handleUpdate = async () => {
        try {

            const error = validateForm();
            if (error) {
                setSideToster({
                    show: 1,
                    message: error,
                    type: "Alert"
                });
                return;
            }

            // extra safety: prevent all images deleted
            if (allImage.length === 0) {
                setSideToster({
                    show: 1,
                    message: "At least one document/image is required",
                    type: "Alert"
                });
                return;
            }

            let formdata = new FormData();

            formdata.append("Id", sendForm.id);
            formdata.append("LandId", JSON.parse(window.sessionStorage.getItem("ProjectData")).landData.id);
            formdata.append("Name", sendForm.name);
            formdata.append("DOB", sendForm.dob);
            formdata.append("IdentityTypeId", sendForm.identityTypeId);
            formdata.append("IdentityNumber", sendForm.identityNumber);

            allImage.forEach((val) => {
                formdata.append("AgreementFiles", val);
            });

            deletedImages.forEach((val) => {
                formdata.append("landAgreementImageIdList", val);
            });

            if (deletedImages.length === 0) {
                formdata.append("landAgreementImageIdList", 0);
            }

            setLoader(1);

            let response = await FileUploadAPI(
                formdata,
                window.RealestateService + `/api/LandAgreement/UpdateLandAgreement`
            );

            let resp = response.data;

            setLoader(0);

            if (resp.status === 1) {
                setSideToster({
                    show: 1,
                    message: "Data Updated",
                    type: "success"
                });

                props.handleActiveTab(2);
            } else {
                setSideToster({
                    show: 1,
                    message: resp.responseValue,
                    type: "Alert"
                });
            }

        } catch (err) {
            setLoader(0);
            setSideToster({
                show: 1,
                message: err.message,
                type: "Alert"
            });
        }
    };

    const handleGotDashboard = () => { }

    useEffect(() => {
        getIdentityDocumentTypeData();
        let landata = JSON.parse(window.sessionStorage.getItem("ProjectData")).landData
        if (landata) {
            getLandAgreementData(landata.id)
        }
    }, [])
    return (
        <>
            <div className='container-fluid landformconatiner p-4' id="AddAgreementHolder">
                <div className='wrapform'>
                    <div className='d-flex flex-column gap-1'>
                        <label className='form-label'>Name</label>
                        <input type='text' name='name' onChange={handleChange} value={sendForm.name} placeholder='Enter Name' className='form-input-box' />
                    </div>
                    <div className='d-flex flex-column gap-1'>
                        <label className='form-label'>DOB</label>
                        <input type='date' max={new Date().toISOString().split("T")[0]} name='dob' onChange={handleChange} value={sendForm.dob} className='form-input-box' />
                    </div>

                    <div className='d-flex flex-column gap-1'>
                        <label className='form-label'>Select Identity Type </label>
                        <select className='form-input-box form-select pe-5' name='identityTypeId' value={sendForm?.identityTypeId} onChange={handleChange}>
                            <option value="-1">--Select Identity Type--</option>
                            {
                                identityTypeList && identityTypeList.map((val, ind) => {
                                    return (
                                        <option value={val.id}>{val.documentType}</option>
                                    )
                                })
                            }
                        </select>
                    </div>

                    <div className='d-flex flex-column gap-1'>
                        <label className='form-label'>Identity Number</label>
                        <input type='text' name='identityNumber' onChange={handleChange} value={sendForm.identityNumber} placeholder='Enter Identity Number' className='form-input-box' />
                    </div>
                </div>
                <FileUpload setDeletedImages={setDeletedImages} deletedImages={deletedImages} setAllImage={setAllImage} allImage={allImage} name="Select Proof Documents" />

            </div>


            <div className='d-flex flex-row justify-content-md-end'>
                {

                    isUpdate === 0 ?

                        <button className='btn export-save-btn' onClick={handleSave}>Save Proof & Next</button>
                        :

                        <div className='d-flex flex-row gap-2'>
                            <button className='btn export-save-btn' onClick={handleUpdate}>Update Proof & Next</button>
                            <button className='btn export-save-btn' onClick={handleGotDashboard}>Cancel</button>
                        </div>
                }
            </div>


            <Loader show={loader} />
            {
                sideToster.show === 1 ?
                    <SideMessage close={setSideToster} show={sideToster.show} type={sideToster.type} message={sideToster.message} />
                    : ""
            }
        </>
    )
}
